module.exports = __webpack_public_path__ + "media/images/mobile/mb-hamburger-cross-a5e761e87f2594b892a0832ba6914b8e.png";